import { render, staticRenderFns } from "./BudgetWizard.vue?vue&type=template&id=70fd8b03&"
import script from "./BudgetWizard.vue?vue&type=script&lang=ts&"
export * from "./BudgetWizard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports